import { API_URL_WHALESHARK_VAULT_CAROUSEL } from "@constants/Clients/whaleshark/whaleshark.env";
import apiInstance from "@services/Shared/instanceAxios";

const getItems = () =>
  apiInstance({
    url: API_URL_WHALESHARK_VAULT_CAROUSEL,
    params: {
      order: "desc",
      sort: "createdAt",
    },
  });

export default getItems;
